"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

var _ThemeToggle = _interopRequireDefault(require("./ThemeToggle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const HeaderWrapper =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "HeaderWrapper",
  class: "HeaderWrapper_h1b6fqjq"
});
const LogoContainer =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "LogoContainer",
  class: "LogoContainer_lz0sul8"
});
const LogoImage =
/*#__PURE__*/
(0, _react2.styled)("img")({
  name: "LogoImage",
  class: "LogoImage_l1tdaxxn"
});

function Header({
  logo
}) {
  return React.createElement(HeaderWrapper, null, React.createElement(LogoContainer, null, logo ? React.createElement(LogoImage, {
    src: logo,
    alt: "Logo"
  }) : null), React.createElement(_ThemeToggle.default, null));
}
//# sourceMappingURL=Header.js.map

require('../css/src/templates/Header.css');
